export enum API_URIS {
  USER = "users",
  LOCATION = "locations",
  PERMISSION_ROLE = "permission/roles"
}

export const INITIAL_QUERY_STATE = {
  sort: "",
  page: 1,
  per_page: 10
};
